import { ITrackEntry, Spine } from "pixi-spine";
import { BetConfig, SlotGameBet } from "../../api";
import { AudioManager, ITrack } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { service } from "../../services";
import { PlaceHolderMutiPotConfig } from "./FillingPotGeneric";
import { ISpineTrackAnimation } from "./IGenericFamilySpine";
import { ILevelAnimation } from "./ILevelAnimationInterface";
import { ILevelMultPot, ILevelsPerBetsSaved } from "./ILevelsPerBetSaved";
import { LayoutPotElement } from "./LayoutPotElement";
import { ShowHitPotElement } from "./ShowHitPotElement";
export class PotElementConstructive implements Resourceful {

    protected allLevelAnimationGrouped: ILevelAnimation[] = [];
    protected countLevelAnimation: number;
    protected availableLevelPerBet: ILevelsPerBetsSaved[] = [];
    protected currentLevelPerBet: ILevelsPerBetsSaved;
    protected currentSpin: number = 0;
    protected percetageIncrementLevels: number = 0;
    protected spinsForHitBonus: number = 0;
    protected currentLevelSaved: number = 0;
    protected currentLevelPlaying: number = 0;
    protected potName: string = "";
    protected gameName: string = "";
    //protected levelAnimationStatus: Map<string, ISpineTrackAnimation> = new Map<string, ISpineTrackAnimation>();
    //protected levelIndexAnim: number;
    public levelAnimationStatusMap: Map<string, ISpineTrackAnimation> = new Map<string, ISpineTrackAnimation>();
    protected spine: Spine = null;
    readonly weights = [0.5, 1]
    //protected levelLoopIndexAnim: number = 0;
    protected systemContext: ISystemContext = null;
    protected startRALevelLoopTimeout: ITimeout = null;
    protected startBonusWinFillingTimeOut: ITimeout = null;
    protected spineTrackMap: Map<string, ITrack> = null
    protected levelSetupStarted : boolean = false;
    protected layoutPotElement : LayoutPotElement = null;
    protected showHitPotElement : ShowHitPotElement = null;
    //protected audio : AudioManager;
    //protected resid : ResourceIdentifier = null;
    protected enabledBets : BetConfig[];  
    constructor(potName: string, enabledBets: BetConfig[], gameName: string, spinsForHitBonus: number,  systemContext: ISystemContext , gameResourcesBasePath : string , audio : AudioManager , resid : ResourceIdentifier) {
        this.spinsForHitBonus = spinsForHitBonus;
        this.potName = potName;
        this.gameName = gameName;
        //this.audio = audio
        //this.resid = resid;
        //this.levelIndexAnim = levelIndexAnim;
       
        let potElement : ILevelMultPot = {
            levelPerBet: [],
            potName: ""
        }

        this.enabledBets = enabledBets ;
        enabledBets.forEach((b) => {

            this.availableLevelPerBet.push({
                currentLevel: 0,
                TotalBet: b.Bet.TotalBetCents.InCents,
                currentSpin: 0,
            })

            //let apiResult = await service.api.storageGetOne(`${gameName}_${potElement}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:",apiResult);
        });



      
       


        //let durationForNextPotLevel = 1 ;

        this.startRALevelLoopTimeout = systemContext.TimingContext().CreateTimeout("StartAnimLoopCurrentLevel", 500, () => {
          
            if (this.spine == null) {
                return
            }

            this.PrepareFinishIncrement();

            this.ClearLastLevel();
            //play anim next loop level
            let newLevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == this.currentLevelPlaying);
            if (newLevelAnimationArray.length > 0) {
                //console.log(`CurrentLevelAnimLoop-${this.currentLevel}:`, newLevelAnimationArray[0]?.levelLoopAnims);
                for (let animationIndex = 0; animationIndex < newLevelAnimationArray[0]?.levelLoopAnims.length; animationIndex++) {
                    let trackAniamtion = this.levelAnimationStatusMap.get(newLevelAnimationArray[0]?.levelLoopAnims[animationIndex]);
                    this.levelAnimationStatusMap.get(newLevelAnimationArray[0]?.levelLoopAnims[animationIndex]).isActive = true;
                    this.levelAnimationStatusMap.get(newLevelAnimationArray[0]?.levelLoopAnims[animationIndex]).loopAnimation = true;
                    this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);
                }
            }
            //lastindex = null;
            newLevelAnimationArray = null;
            //this.OnLevelSetupFinishedAnim(this.potName , this.currentLevelPlaying);
        });

        this.startBonusWinFillingTimeOut = systemContext.TimingContext().CreateTimeout("StartBonusWinFillingTimeOut", 600, () => {
            this.ClearLevels();
            //this.spineHit?.state?.clearTrack(this.trackIndexAnimSpecialGameConnected);
            this.spine?.state?.clearTrack(0);

            //this.spineTrackMap.get("collectHitBonus")?.PlayLoop(Track.LoopForEver);
            if (this.levelAnimationStatusMap.has(`${this.potName}/BN_BONUS_${this.potName}`) && this.spine?.state) {
                let animationTrack = this.levelAnimationStatusMap.get(`${this.potName}/BN_BONUS_${this.potName}`);
                this.levelAnimationStatusMap.get(`${this.potName}/BN_BONUS_${this.potName}`).isActive = true;
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
            }

            this.currentLevelSaved = 0;
            this.currentSpin = 0;
        });

        this.layoutPotElement = new LayoutPotElement(potName,gameResourcesBasePath , this.gameName , systemContext , audio , resid);
        if(this.potName == "Multiplier")this.showHitPotElement = new ShowHitPotElement(potName,gameResourcesBasePath , this.gameName , systemContext , audio , resid);
    }  


    public async PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        await this.layoutPotElement.PrepareResources(resourceManager);
        await this.showHitPotElement?.PrepareResources(resourceManager);
    }

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        await this.layoutPotElement.ResourcesLoaded(resourceManager);
        await this.showHitPotElement?.ResourcesLoaded(resourceManager);

        this.enabledBets.forEach((b) => {
            // let apiResult = await service.api.storageGetOne(`${this.gameName}_${this.potName}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:", apiResult);
            let betFind = this.availableLevelPerBet.find(lbet => lbet.TotalBet == b.Bet.TotalBetCents.InCents);
            // if (apiResult == null) return
            betFind.currentLevel = parseInt('0');
        });
    }

    
    public CreatePot(spine: Spine , placeHolderMutiPotConfig : PlaceHolderMutiPotConfig , spineTrackMap: Map<string, ITrack> ) {
        spineTrackMap = spineTrackMap;
        console.log("placeHolderMutiPotConfig:",placeHolderMutiPotConfig);
        this.spine = spine
        //find Animation LevelStart         
        let regex = new RegExp(`LA_${this.potName}_([0-9]+)_`);
        let animations = this.spine.skeleton?.data.animations.map(s => s.name);
        let levels = animations
            .map(a => a.match(regex))
            .filter(l => l != null)
            .map(l => l[0]);
        let uniqueLevels = levels.filter((item, index, array) => array.indexOf(item) == index);
        this.allLevelAnimationGrouped = uniqueLevels.map(l => ({
            level: parseInt(l.match(regex)[1]),
            //level: parseInt(l.match(/LA_Extended_([0-9]+)_/)[1]),
            levelStartAnims: animations.filter(a => a.includes(l + "LevelStar")),
            levelLoopAnims: animations.filter(a => a.includes(l + "Loop"))
        }))
            .sort((a, b) => a.level - b.level);


        this.countLevelAnimation = this.allLevelAnimationGrouped.length;
        //console.log(`PotElementLevels_AllLevels_${this.potName}:`, this.allLevelAnimationGrouped);
        regex = null;
        animations = null;
        levels = null;
        uniqueLevels = null;
        //animationGrouped = null;




        //console.log(`PotElementLevels_AllBets_${this.gameName}-${this.potName}`, this.availableLevelPerBet);

        this.spine.skeleton.data.animations.forEach((animation, index) => {
            let spineTrackAnimation: ISpineTrackAnimation = {
                trackAnimationIndex: 0,
                loopAnimation: false,
                soundTrack: null,
                duration: 0,
                animationName: "",
                isActive: false
            }
            //console.log("SpineTrack:",animation.name);
            spineTrackAnimation.duration = animation.duration;
            spineTrackAnimation.animationName = animation.name;
            if (animation.name.match(new RegExp(`LA_${this.potName}_([0-9]+)_LevelStart`))) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                if (spineTrackMap.has(`LevelAnimation_${animation?.name?.match(/_(\d+_LevelStart)$/)?.[1]}`) == true){
                    //console.log("SpineTrack:",`LevelAnimation_${animation.name.match(/_(\d+_LevelStart)$/)[1]}`);
                    spineTrackAnimation.soundTrack = spineTrackMap.get(`LevelAnimation_${animation.name.match(/_(\d+_LevelStart)$/)[1]}`);
                }
            }
            else if (animation.name.match(new RegExp(`LA_${this.potName}_([0-9]+)_Loop`))) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = true;
                //spineTrackAnimation.duration = animation.duration;
                //spineTrackAnimation.animationName = animation.name;
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }
            else if (animation.name.match(new RegExp(`LA_${this.potName}_Full_LevelStart`))) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                //spineTrackAnimation.duration = animation.duration;
                //spineTrackAnimation.animationName = animation.name;
                spineTrackAnimation.soundTrack = spineTrackMap.get("LevelAnimation_Full_LevelStart");
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }
            else if (animation.name.match(new RegExp(`LA_${this.potName}_Default`))) {
                spineTrackAnimation.trackAnimationIndex =  index; 
                spineTrackAnimation.loopAnimation = true;  
                spineTrackAnimation.isActive = true;
                //spineTrackAnimation.duration = animation.duration;
                //spineTrackAnimation.animationName = animation.name;                               
            }
            else if (animation.name.includes(`BN_BONUS_${this.potName}`)) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = spineTrackMap.get("collectHitBonus");
                
                //spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitBonus");
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }

            else if (animation.name.includes(`BN_START_${this.potName}`)) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = spineTrackMap.get("BN_START");
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }
            else if (animation.name.includes(`EXPECTATION_${this.potName}`)) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack =  spineTrackMap.get("spineAnticipation");
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }
            else if (animation.name.includes(`LevelSetupEnd_${this.potName}`)) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                ///spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitBonus");
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }
            else if (animation.name.includes(`LevelSetupStart_${this.potName}`)) {
                spineTrackAnimation.trackAnimationIndex = index;
                spineTrackAnimation.loopAnimation = false;
                ///spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitBonus");
                //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
            }
            else {
                return
            }


            this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);

            spineTrackAnimation = null;
            //console.log(`PotElementLevels_StatusAnims${this.gameName}-${this.potName}-`,this.levelAnimationStatusMap);
        });      
        this.CreateLayout(placeHolderMutiPotConfig);
        this.SetMixAnimation();
    }

    protected SetMixAnimation() {
        for (let indexLevel = 0; indexLevel < this.allLevelAnimationGrouped.length; indexLevel++) {
            if (this.levelAnimationStatusMap.has(`${this.potName}/LA_${this.potName}_Default`)){
                this.spine?.state.data.setMix(`${this.potName}/LA_${this.potName}_Default`, this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], 0);            
                if (this.allLevelAnimationGrouped[indexLevel].levelLoopAnims.length >= 1 ) this.spine?.state.data.setMix(`${this.potName}/LA_${this.potName}_Default`, this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], 0);            
                          
                if (this.allLevelAnimationGrouped[indexLevel].levelLoopAnims.length >= 1 ) this.spine?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], `${this.potName}/LA_${this.potName}_Default`, 0);
                this.spine?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], `${this.potName}/LA_${this.potName}_Default`, 0);
            }
            if (this.allLevelAnimationGrouped[indexLevel].levelLoopAnims.length >= 1 ) this.spine?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], 0);         
            if ((indexLevel + 1) < this.allLevelAnimationGrouped.length) return
            if (this.allLevelAnimationGrouped[indexLevel].levelLoopAnims.length >= 1 )this.spine?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], this.allLevelAnimationGrouped[indexLevel+1].levelStartAnims[0], 0);         
            this.spine?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], this.allLevelAnimationGrouped[indexLevel+1].levelStartAnims[0], 0);
             
        }

        this.spine?.state.data.setMix(`${this.potName}/LA_${this.potName}_Default`, `${this.potName}/BN_START_${this.potName}`, 1)
        this.spine?.state.data.setMix(`${this.potName}/LA_${this.potName}_Default`, `${this.potName}/BN_BONUS_${this.potName}`, 1)
    }

    protected CreateLayout(placeHolderMutiPotConfig : PlaceHolderMutiPotConfig){
        this.layoutPotElement.CreateElementIntoFillingPotSpine(this.spine , placeHolderMutiPotConfig );
        this.showHitPotElement?.CreateElementIntoFillingPotSpine(this.spine , placeHolderMutiPotConfig );
        
    }

    public ClearLastLevel() {
      
        let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == this.currentLevelPlaying - 1);

        for (let animationIndex = 0; animationIndex < (LevelAnimationArray?.[0]?.levelStartAnims?.length ?? 0); animationIndex++) {
            this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).isActive = false;
            this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).loopAnimation = false;
            // if (this.tracksEnabled.has(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]) == true) {
            //     //this.tracksEnabled.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).track = this.levelIndexAnim + animationIndex;
            //     this.tracksEnabled.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).loop = false;
            //     this.tracksEnabled.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).enable = false;
            // }
            this.spine?.state?.clearTrack(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex);
            //this.spine?.state?.addEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0, 0);
            //this.spine?.state?.setEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0);
        }
        for (let animationIndex = 0; animationIndex < (LevelAnimationArray?.[0]?.levelLoopAnims?.length ?? 0); animationIndex++) {
            this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).isActive = false;
            this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).loopAnimation = false;
            // if (this.tracksEnabled.has(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]) == true) {
            //     //this.tracksEBOnabled.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).track = this.levelIndexAnim + animationIndex;
            //     this.tracksEnabled.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).loop = false;
            //     this.tracksEnabled.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).enable = false;
            // }
            this.spine?.state?.clearTrack(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex);
            //this.spine?.state?.addEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0, 0);
            //this.spine?.state?.setEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0);
        }
        LevelAnimationArray = null;

    }

    public ClearLevels() {

        for (let restartcurrentLevel = 1; restartcurrentLevel <= this.countLevelAnimation; restartcurrentLevel++) {
            let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == restartcurrentLevel);
            for (let animationIndex = 0; animationIndex < (LevelAnimationArray?.[0]?.levelStartAnims?.length ?? 0); animationIndex++) {
                this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).isActive = false;
                this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).loopAnimation = false;
                this.spine?.state?.addEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0, 0);
                this.spine?.state?.setEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0);
            }
            for (let animationIndex = 0; animationIndex < (LevelAnimationArray?.[0]?.levelLoopAnims?.length ?? 0); animationIndex++) {
                this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).isActive = false;
                this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).loopAnimation = false;
                this.spine?.state?.addEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0, 0);
                this.spine?.state?.setEmptyAnimation(this.levelAnimationStatusMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0);
            }
            LevelAnimationArray = null;
        }
    }


    
    public IncrementLevels() {
        //console.log("StartIncrement-NamePot:", this.potName)
        if (this.isPosibleHitNextLevel() == true) {
            //let durationLevelSetupStart = 1;
            this.PrepareIncrement()
        } else if (this.currentLevelSaved >= this.countLevelAnimation) {
            //nothing to do 
            //console.log(`${this.gameName}-${this.potName}-PrepareIncrement-Full-Level-Element`);
            this.PrepareIncrement()

        } else {
            //nothing to do send call back for finish level increment 
            this.OnLevelSetupFinishedAnim(this.potName, this.currentLevelPlaying);
        }
        //newLevel = null;
        this.SavePotCurrentIncrement();
    }

    protected PrepareIncrement() {
        // if (this.levelAnimationStatusMap.has(`${this.potName}/LevelSetupStart_${this.potName}`) && this.spine?.state) {
        //     this.levelSetupStarted = true;
        //     let trackAniamtion = this.levelAnimationStatusMap.get(`${this.potName}/LevelSetupStart_${this.potName}`)
        //     //durationLevelSetupStart = trackAniamtion.duration;
        //     this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);
        // }
        this.PrepareIncrementOnFinished();
    }

    protected PrepareFinishIncrement(delay : number = 0 ){
        // if (this.levelAnimationStatusMap.has(`${this.potName}/LevelSetupEnd_${this.potName}`) && this.spine?.state && this.levelSetupStarted == true) {
        //     let trackAniamtion = this.levelAnimationStatusMap.get(`${this.potName}/LevelSetupEnd_${this.potName}`)                
        //     //this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);
        //     this.AddQueueAnimation(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, false, delay , this.spine);
        //     trackAniamtion.isActive == false;
        //     trackAniamtion.loopAnimation == false;                
        // }  
        
        this.PrepareFinishIncrementOnFinished()
    }

    protected PrepareIncrementOnFinished() {
        
        this.ClearDefaultAnim();
        if (this.currentLevelSaved <  this.countLevelAnimation) {  
            //this.layoutPotElement.WinPot();          
            this.ClearLastLevel()
            this.currentLevelSaved++;
            this.currentLevelPlaying = this.currentLevelSaved;
            let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == this.currentLevelPlaying);
            for (let animationIndex = 0; animationIndex < LevelAnimationArray[0]?.levelStartAnims.length; animationIndex++) {
                let trackAnimation = this.levelAnimationStatusMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]);
                this.levelAnimationStatusMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]).isActive = false;
                this.levelAnimationStatusMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]).loopAnimation = false;
                this.startRALevelLoopTimeout.ChangeTimeout(trackAnimation.duration * 1000);
                this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
            }
            this.OnLevelSetupStartFinishedAnim(this.potName,this.currentLevelPlaying);
            this.startRALevelLoopTimeout.Start();
        }
        else if (this.currentLevelSaved >= this.countLevelAnimation) {
            //this.layoutPotElement.WinPot();
            //this.ClearLevels();
            let delayFullLevel = 1 ;
            if (this.levelAnimationStatusMap.has(`${this.potName}/LA_${this.potName}_Full_LevelStart`) && this.spine?.state) {
                let trackAniamtion = this.levelAnimationStatusMap.get(`${this.potName}/LA_${this.potName}_Full_LevelStart`)
                this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);
                //if(this.spineTrackMap.has("LevelAnimation_Full_LevelStart"))this.spineTrackMap.get("LevelAnimation_Full_LevelStart").Play();
                //console.log(`${this.gameName}-${this.potName}-FullLevelStartAnimation`);
                delayFullLevel = trackAniamtion.duration;
            }

            this.PrepareFinishIncrement(delayFullLevel);
            //}
        } else {
            //nothing to do send call back for finish level increment 
            this.OnLevelSetupFinishedAnim(this.potName, this.currentLevelPlaying);
        }
        //newLevel = null;
        this.SavePotCurrentIncrement();
    }

    protected PrepareFinishIncrementOnFinished(){
        this.levelSetupStarted = false;
        this.OnLevelSetupFinishedAnim(this.potName, this.currentLevelPlaying);
    }

    public isPosibleHitNextLevel(){        
        //this.percetageIncrementLevels = this.currentSpin * (this.countLevelAnimation / this.spinsForHitBonus);
        let newLevel = this.currentLevelSaved + 1;
        //console.log(`${this.potName}-LevelNEw : ` ,newLevel);
        //console.log(`${this.potName}-LevelNEw - CurrentSpin : `,this.currentSpin);
        ///console.log(`${this.potName}-LevelNEw - CurrentLevel : `,this.currentLevelSaved);
        //console.log(`${this.potName}-LevelNEw - CurrentLevelPlaying : `,this.currentLevelPlaying);
        //console.log(`${this.potName}-LevelNEw - CurrentLevel-Percentage : `,this.percetageIncrementLevels);        
        if(newLevel <= this.countLevelAnimation ) return true
        else return false
    }

    protected selectedBet : SlotGameBet;
    public SetBetByLevel(selectedBet: SlotGameBet) {
        this.selectedBet = selectedBet;
        this.currentLevelPerBet = this.availableLevelPerBet.find(levelPerBet => levelPerBet.TotalBet == this.selectedBet?.TotalBetCents?.InCents);
        this.currentSpin = this.currentLevelPerBet.currentSpin;
        this.percetageIncrementLevels = this.currentSpin * (this.countLevelAnimation / this.spinsForHitBonus);
        this.currentLevelSaved = this.currentLevelPerBet.currentLevel;
        this.currentLevelPlaying = this.currentLevelPerBet.currentLevel;
        //console.log(`PotElementLevels_${this.gameName}-${this.potName}-CurrentBet`, this.currentLevelPerBet);
        //console.log(`PotElementLevels_${this.gameName}-${this.potName}-AllBets`, this.availableLevelPerBet);
        this.ResetPoseSpine();
        this.ResetPotByDefault();
    }

    protected ResetPotByDefault() {               
                
        for (let restartcurrentLevel = this.currentLevelSaved; restartcurrentLevel <= this.currentLevelSaved; restartcurrentLevel++) {
            let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == restartcurrentLevel);
            //console.log(`ResctartLevelAnim-${restartcurrentLevel}:`, LevelAnimationArray[0]?.levelStartAnims);
            if (LevelAnimationArray.length == 0) break
            for (let animationIndex = 0; animationIndex < LevelAnimationArray[0]?.levelStartAnims.length; animationIndex++) {
                let trackAnimation = this.levelAnimationStatusMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]);
                this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack, 1);
                //this.AddQueueAnimation(trackAnimation.animationName , trackAnimation.trackAnimationIndex , true , 0 , this.spine);           
                this.startRALevelLoopTimeout.ChangeTimeout(trackAnimation.duration * 1000);
            }
            LevelAnimationArray = null;
        };
        this.StartDefaultAnim();
        this.startRALevelLoopTimeout.Start();
    }

    protected StartDefaultAnim() {
        if (this.currentLevelSaved == 0) {
            if (this.levelAnimationStatusMap.has(`${this.potName}/LA_${this.potName}_Default`) == true && this.spine != null) {
                let trackAnimation = this.levelAnimationStatusMap.get(`${this.potName}/LA_${this.potName}_Default`);
                this.levelAnimationStatusMap.get(trackAnimation.animationName).isActive = true;
                this.levelAnimationStatusMap.get(trackAnimation.animationName).loopAnimation = true;
                //this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
                this.AddQueueAnimation(trackAnimation.animationName , trackAnimation.trackAnimationIndex , true , 0 , this.spine);
            }
        } else {
            this.ClearDefaultAnim();
        }
    }


    protected ClearDefaultAnim(){
        //if (this.currentLevelSaved > 0)     
        if (this.levelAnimationStatusMap.has(`${this.potName}/LA_${this.potName}_Default`) == true && this.spine != null) {   
            let trackAnimation = this.levelAnimationStatusMap.get(`${this.potName}/LA_${this.potName}_Default`);
            this.levelAnimationStatusMap.get(trackAnimation?.animationName).isActive = false;
            this.levelAnimationStatusMap.get(trackAnimation?.animationName).loopAnimation = false;
            this.spine?.state?.clearTrack(trackAnimation?.trackAnimationIndex);
        }
    }

    public UpdateSpinPotElemet() {
        this.currentSpin++;
        //console.log("Bet-CurrentSpin:", this.currentSpin);
        this.percetageIncrementLevels = this.currentSpin * (this.countLevelAnimation / this.spinsForHitBonus);
        //console.log(`PotElementLevels_${this.gameName}-${this.potName}-CurrentBet`, this.currentLevelPerBet);
        //this.SavePotCurrentIncrement();
    }

    public SavePotCurrentIncrement() {
        this.currentLevelPerBet.currentSpin = this.currentSpin;
        this.currentLevelPerBet.currentLevel = this.currentLevelSaved;
        //this.selectedBetPotLevelMap.set(bonus,currentLevelPerBet);
        //console.log("Levels_CurrentBet:",this.selectedBetPotLevelMap);   
        console.log(`PotElementLevels_${this.gameName}-${this.potName}`, this.currentLevelPerBet);

        
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // service.api.storageSetOne(`${this.gameName}_${this.potName}_${this.selectedBet.TotalBetCents.InCents}`,this.currentLevelSaved.toString());
        // localStorage.setItem(`${this.gameName}_${this.potName}_${this.selectedBet.TotalBetCents.InCents}`,this.currentLevelSaved.toString());
    }


    protected PlayAnimationSpine(nameAnimation: string, trackAnimationIndex: number, soundTrack: ITrack, speedAnimation: number = null, loopAnim: boolean = false, trackComplete?: ITrackEntry) {
        if (loopAnim == true) {
            trackComplete.trackTime = 0;
            soundTrack?.Play(false);
        }
        else {
            this.spine?.state?.addEmptyAnimation(trackAnimationIndex, 0, 0);
            this.spine?.state?.setEmptyAnimation(trackAnimationIndex, 0);
            let trackAnimation = this.spine?.state?.setAnimation(trackAnimationIndex, nameAnimation, false);
            if (trackAnimation && speedAnimation != null) {
                trackAnimation.timeScale = speedAnimation;
            }
            //this.allAnimationMap.get(nameAnimation).trackAnimationIndex = trackAnimationIndex;
            soundTrack?.Play(false);
        }
    }

    public AnimComplete(trackComplete: ITrackEntry) {
        //const anim = trackComplete.animation;
        if (this.levelAnimationStatusMap.get(trackComplete.animation.name)?.loopAnimation == true) {
            let trackAnimation = this.levelAnimationStatusMap.get(trackComplete.animation.name);
            this.PlayAnimationSpine(trackAnimation.animationName, trackComplete.trackIndex, trackAnimation.soundTrack, null, true, trackComplete);
        }
        else {            
            if (this.levelAnimationStatusMap.has(trackComplete.animation.name) == false) return
            //if(trackComplete.animation.name.includes(`LevelSetupStart_${this.potName}`)) this.PrepareIncrementOnFinished();
            //if(trackComplete.animation.name.includes(`LevelSetupEnd_${this.potName}`)) this.PrepareFinishIncrementOnFinished()               
            this.spine?.state?.clearTrack(trackComplete.trackIndex);
        }
        //console.log(`tracksAnims`, this.tracksEnabled);
    }

    public StartBonusWin(multiplier : number) {     
        this.ClearDefaultAnim()
        this.layoutPotElement.WinPot(true); 
        this.ClearLastLevel();
        let CheckRealLevel = this.currentLevelPlaying == 0 ? 0 : this.currentLevelPlaying
        if (this.currentLevelPlaying < this.countLevelAnimation && this.spine != null) {
            //let CheckRealLevel = this.currentLevelPlaying == 0 ? 0 : this.currentLevelPlaying
            this.currentLevelPlaying = this.currentLevelPlaying == 0 ? 1 : this.currentLevelPlaying;
            for (let currentLevelAnim = this.currentLevelPlaying; currentLevelAnim <= this.countLevelAnimation; currentLevelAnim++) {
                if(CheckRealLevel >= 1 )this.ClearLastLevel();
                let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == currentLevelAnim);
                for (let animationIndex = 0; animationIndex < LevelAnimationArray[0]?.levelStartAnims.length; animationIndex++) {
                    let trackAnimation = this.levelAnimationStatusMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]);
                    //this.spine?.state?.addEmptyAnimation(trackAnimation.trackAnimationIndex + animationIndex, 0, 0);
                    //this.spine?.state?.setEmptyAnimation(trackAnimation.trackAnimationIndex + animationIndex, 0);
                    this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, null, 20);
                }
                LevelAnimationArray = null;
            }
        }


            if(CheckRealLevel >= 1 ) this.ClearLevels();            
            if (this.levelAnimationStatusMap.has(`${this.potName}/BN_START_${this.potName}`) && this.spine?.state) {
                let animationTrack = this.levelAnimationStatusMap.get(`${this.potName}/BN_START_${this.potName}`);
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                this.startBonusWinFillingTimeOut.ChangeTimeout((animationTrack.duration * 1000) + 500)
            }

            this.showHitPotElement?.SetMultiplier(multiplier);
            this.layoutPotElement?.SetMultiplier(multiplier);

            this.startBonusWinFillingTimeOut?.Start();

            this.currentLevelSaved = 0;
            this.currentSpin = 0;
            this.currentLevelPlaying = 0;
            this.SavePotCurrentIncrement();

            CheckRealLevel = null;
    }

    //protected animationExpectation : ITrackEntry = null
    public StartAnticipationBegin() {        
        if (this.levelAnimationStatusMap.has(`${this.potName}/EXPECTATION_${this.potName}`) == true && this.spine != null) {
            let trackAnimation = this.levelAnimationStatusMap.get(`${this.potName}/EXPECTATION_${this.potName}`);
            this.levelAnimationStatusMap.get(`${this.potName}/EXPECTATION_${this.potName}`).isActive = true;
            this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack)
        }
    }

    public EndAnticipationBegin() {
        if (this.levelAnimationStatusMap.has(`${this.potName}/EXPECTATION_${this.potName}`) == true) this.levelAnimationStatusMap.get(`${this.potName}/EXPECTATION_${this.potName}`).isActive = false;
    }

    public GetAllLevels() {
        return this.countLevelAnimation
    }

    public IsFullLevel(){
        if(this.currentLevelSaved >= this.countLevelAnimation) return true
        return false
    }

    public LevelDebugger(levelTestit: number) {
        this.currentSpin = levelTestit
        this.percetageIncrementLevels = levelTestit;
        this.currentLevelSaved = levelTestit - 1;
        this.currentLevelPlaying = levelTestit - 1;
    }
    public GetName() {
        return this.potName
    }

    public OnLevelSetupFinishedAnim: OnLevelSetupFinishedAnim = null;
    public OnLevelSetupStartFinishedAnim: OnLevelSetupStartFinishedAnim = null;

    public GetCurrentLevels() : ILevelMultPot{
        return {
            potName : this.potName ,
            levelPerBet : this.availableLevelPerBet
        }
    }

    public SetCurrentFromBaseGameLevels(availableLevelPerBet : ILevelsPerBetsSaved[] ){
        this.availableLevelPerBet =  availableLevelPerBet
    }

    protected AddQueueAnimation(nameAnimation: string, trackAnimationIndex: number, loopAnim = false, delay: number = 0 , spine : Spine) {
        spine?.state?.addAnimation(trackAnimationIndex, nameAnimation, loopAnim, delay);
    }

    public Destroy (){
        this.showHitPotElement?.Destroy();
        this.layoutPotElement?.Destroy();
    }

    public ReelStops(){
        this.layoutPotElement.ReelStopAnim();
    }

    public RamclearLevel(selectedBet: SlotGameBet) {
        this.enabledBets.forEach((b) => {
            //await service.api.storageDeleteOne(`${this.gameName}_${this.potName}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:", apiResult);
            let betFind = this.availableLevelPerBet.find(lbet => lbet.TotalBet == b.Bet.TotalBetCents.InCents);
            if (betFind == null) return
            betFind.currentLevel = 0;
        });

        //console.log("Ramclear:",this.availableLevelPerBet)
        console.log(`Ramclear-MultibonosFillingPotComplete-${this.gameName}-${this.potName}`,this.spine);
        
        this.ClearLevels(); 
        if(this.spine == null) return
        //await this.ResetPoseSpine();
        this.SetBetByLevel(selectedBet);
    }

    protected ResetPoseSpine() {
        this.spine?.skeleton?.setBonesToSetupPose();
        this.spine?.skeleton?.setToSetupPose();
        this.spine?.skeleton?.setSlotsToSetupPose();
        //this.spine?.update(0);
    }

    public WinPot(){
        this.layoutPotElement.WinPot(false); 
    }
}
export type OnLevelSetupFinishedAnim = (potName : string , currentLevel : number ) => void;
export type OnLevelSetupStartFinishedAnim = (potName : string , currentLevel : number ) => void;